import { render, staticRenderFns } from "./storeaddress-edit.vue?vue&type=template&id=1bf6b5ec&"
import script from "./storeaddress-edit.vue?vue&type=script&lang=ts&"
export * from "./storeaddress-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports